"use client";

import React, { createContext, useContext } from "react";

import { usePathname } from "next/navigation";

const DraftModeContext = createContext(false);

export function useDraftModeContext(): boolean {
  return useContext(DraftModeContext);
}

function DraftModeBanner() {
  const pathname = usePathname();

  return (
    <div className="fixed bottom-0 left-0 z-50 flex items-center gap-3 rounded-tr-md bg-amber-400 px-3 py-1.5 text-sm font-semibold text-slate-900 shadow-md">
      <span>Draft mode</span>
      <a
        className="underline hover:no-underline"
        href={`/api/disable-draft?path=${encodeURIComponent(pathname)}`}
      >
        Exit
      </a>
    </div>
  );
}

export default function DraftModeProvider({
  children,
  isDraftMode,
}: {
  children: React.ReactNode;
  isDraftMode: boolean;
}) {
  return (
    <DraftModeContext.Provider value={isDraftMode}>
      {children}
      {isDraftMode && <DraftModeBanner />}
    </DraftModeContext.Provider>
  );
}
